enum links {
	RECHERCHE_OFFRE = '/recherche-offre',
	OFFRE = '/offre',
	DOSSIER = '/dossier',
	PLANIFICATION_VISITE = '/planification-visite',
	RECHERCHE_CONTACT = '/recherche-contact',
	CREATION_CONTACT = '/creation-contact',
	DETAILS_CONTACT = '/details-contact'
}

export default links
